'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'dumpster';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f793';
var svgPathData = 'M45.6 80l-26.7 160 12 0 0 0 90.1 0 21.8-160-97.3 0zM559.8 256l-16.7 0-28.9 224-16.1 0 4.1-32-428.3 0 4.1 32-16.1 0-28.9-224-33 0 2.7-16 29.3-176 512 0 29.3 176 2.7 16-16.2 0zm-32.9 0l-477.8 0 22.7 176 432.4 0 22.7-176zm18.2-16l0 0 12 0-26.7-160-97.6 0 22.1 160 90.1 0zM296 80l0 160 142.8 0-22.1-160-120.7 0zM159 80l-21.8 160 142.8 0 0-160-121 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpster = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;